import React from "react";
import { motion } from "framer-motion";
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "./ui/accordion";
import { FAQ_GROUPS } from "../constants/content";

let globalIndex = -1;

const FaqSection = () => {
    globalIndex = -1;
    return (
        <section id="faq" data-testid="faq-section" className="relative py-28 sm:py-36">
            <div className="mx-auto max-w-3xl px-5 sm:px-8">
                <motion.p
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.6 }}
                    className="font-mono-tech text-center text-[11px] uppercase tracking-[0.35em] text-neon-blue"
                >
                    Frequently Asked Questions
                </motion.p>
                <motion.h2
                    initial={{ opacity: 0, y: 32 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.7, delay: 0.1 }}
                    className="font-display mt-5 text-center text-3xl font-extrabold text-white sm:text-5xl"
                >
                    Everything you need to <span className="text-gradient-neon">get started</span>
                </motion.h2>

                <motion.div
                    initial={{ opacity: 0, y: 32 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-60px" }}
                    transition={{ duration: 0.7, delay: 0.2 }}
                    className="mt-14"
                >
                    <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
                        {FAQ_GROUPS.map((g) => (
                            <div key={g.group} className="mb-8">
                                <p className="font-mono-tech mb-3 text-[11px] uppercase tracking-[0.3em] text-neon-pink">
                                    {g.group}
                                </p>
                                {g.items.map((f) => {
                                    globalIndex += 1;
                                    const i = globalIndex;
                                    return (
                                        <AccordionItem
                                            key={i}
                                            value={`item-${i}`}
                                            data-testid={`faq-item-${i}`}
                                            className="border-border"
                                        >
                                            <AccordionTrigger
                                                data-testid={`faq-trigger-${i}`}
                                                className="text-left font-display text-sm font-semibold text-white hover:text-neon-blue sm:text-base"
                                            >
                                                {f.q}
                                            </AccordionTrigger>
                                            <AccordionContent className="text-sm leading-relaxed text-white/70">
                                                {f.a}
                                            </AccordionContent>
                                        </AccordionItem>
                                    );
                                })}
                            </div>
                        ))}
                    </Accordion>
                </motion.div>
            </div>
        </section>
    );
};

export default FaqSection;
